import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import { connect } from 'react-redux';
import { LOADING_STATE } from 'components/Login/redux';
import { getCookie } from 'utils/cookies';
import {
  gtag,
  // enableBodyScroll,
  // disableBodyScroll,
  getQueryParams,
  fireCustomDimension,
} from 'utils/common';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { getPrcCookieValue } from 'utils/primeUtil';
import {
  // PRC_PRIME_API_MOB,
  // PRC_PRIME_API_DESKTOP,
  // ALREADY_PRIME_USER_STORAGE_NAME,
  // TOI_SUBS_FETCH_ORDER_STATUS_WEB,
  // TOI_SUBS_FETCH_ORDER_STATUS_MWEB,
  ET_SUBSCRIPTION_STATUS,
  ET_X_CLIENT_ID_WEB,
  ET_X_CLIENT_ID_WAP,
  ET_X_SITE_APP_CODE,
} from 'constants/index';
import { alertLogger } from 'helpers/logAlert/AlertLogger';
// import { clearBrowserStorageKey } from 'components/ToiSubscription/utils/browserStorageData';
// import {
//   SuccessScreen,
//   PendingScreen,
//   FailureScreen,
//   Unreachable,
//   TimesPrimeSuccessScreen,
//   PerStorySuccessScreen,
//   CredStatusScreen,
// } from './Status/index';
import BROWSER_STORAGE_KEY from '../../config';

const PAYMENT_STATUS_SCREEN = {
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PAYMENT_UNREACHABLE: 'PAYMENT_UNREACHABLE',
};

// const setNativePrc = (isMobile = false) => {
//   const API = isMobile ? PRC_PRIME_API_MOB : PRC_PRIME_API_DESKTOP;
//   makeRequest.get(API, {
//     withCredentials: true,
//   });
// };

const getCachedOrderId = () => {
  let transcode = '';
  if (typeof window !== 'undefined') {
    transcode = getQueryParams('transcode');
  }
  return transcode;
};

const ToiSubscriptionStatus = ({
  // prcStatusDetails,
  // userData,
  // startTOIPaymentFlow,
  // triggerMailOnContactUs,
  // userPhone,
  // hideLoader,
  isWapView,
  // currencyCode,
  geoCountry,
  msid,
  storyTitle,
  // viewLoader,
  // inPreExpirePeriod,
  // inGracePeriod,
  // remainingDays,
  userPrcData,
  // loadUserPrcData,
  loading,
  // hasGSTFormFilled,
  // callback,
  // startGstFlowNode,
}) => {
  // const storedPlanOption = JSON.parse(localStorage.getItem('planOption'));
  const storedPlanOption = '';
  // const credData =
  //   sessionStorage.getItem(`prime_${getCookie('prc')}`) &&
  //   JSON.parse(sessionStorage.getItem(`prime_${getCookie('prc')}`))?.credData;
  // const [accessType, setAccessType] = useState('');
  // const [orderId, setOrderId] = useState('');
  // const [credErrorStatus, setCredErrorStatus] = useState('');
  // const [count, setCount] = useState(0);
  // const [planId, setPlanId] = useState('');
  // const [screenToShow, setScreenToShow] = useState({
  //   statusScreen: null,
  //   showScreenGA: true,
  // });
  // const [planNameForCD, setPlanNameForCD] = useState('');
  // const [durationForCD, setDurationForCD] = useState('');
  const prc = getPrcCookieValue();
  const duration = '';
  let planName = '';
  // const paymentData = {};
  // let timerId = '';
  // const renderScreen = (status, isRetryClick) => {
  //   const screenType = PAYMENT_STATUS_SCREEN[status];
  //   if (isRetryClick) {
  //     setScreenToShow({
  //       statusScreen: screenType,
  //       showScreenGA: true,
  //     });
  //   } else {
  //     setScreenToShow({
  //       ...screenToShow,
  //       statusScreen: screenType,
  //     });
  //   }
  // };
  const removeFromLocalStorage = arr => {
    if (Array.isArray(arr) && arr.length) {
      arr.forEach(key => localStorage.removeItem(key));
    }
  };
  // const firePurchaseTypeDimension = () => {
  //   if (typeof window !== 'undefined' && window.localStorage) {
  //     const newPurschaseType = localStorage.getItem('newPurschaseType');
  //     if (newPurschaseType) {
  //       fireCustomDimension(newPurschaseType, 'dimension53');
  //     }
  //     localStorage.removeItem('newPurschaseType');
  //   }
  // };
  // const hideStatus = (doPageRefresh, removeLocalStorage, options = {}) => {
  //   if (options?.event) {
  //     options.event.preventDefault();
  //   }
  //   setScreenToShow({
  //     ...screenToShow,
  //     statusScreen: false,
  //   });
  //   if (removeLocalStorage) {
  //     removeFromLocalStorage([
  //       BROWSER_STORAGE_KEY,
  //       'paymentSuccess',
  //       'toi_cookie',
  //       'planOption',
  //       'cred_login_failure',
  //       'nudgeClickInfo',
  //     ]);
  //   }
  //   enableBodyScroll();
  //   if (doPageRefresh) {
  //     sessionStorage.removeItem(ALREADY_PRIME_USER_STORAGE_NAME);
  //     if (options?.url) {
  //       window.location.href = options.url;
  //     } else {
  //       window.location.reload(true);
  //     }
  //   }
  // };

  const fireGA = (action, label) => {
    if (typeof window !== 'undefined') {
      analyticsWrapper('ga', 'send', 'event', 'TOIPlus', action, label);
    }
  };

  const fireGAOnApiResponse = (status, planAccessType, extraData = {}) => {
    let gaAction = '';
    let gaLabel = '';
    const oldPRC = localStorage.getItem('oldPRC');
    const clickNudgeInfoValue = extraData?.clickNudgeInfoValue;
    const initMsid = clickNudgeInfoValue?.msid;
    const initStoryTitle = clickNudgeInfoValue?.storyTitle;
    if (status === PAYMENT_STATUS_SCREEN.PAYMENT_SUCCESS) {
      if (
        planAccessType === 'PAY_PER_ARTICLE' &&
        storedPlanOption !== 'credOption'
      ) {
        gaLabel = storyTitle;
        if (oldPRC) {
          gaAction = `TOIPlus_PRCNA_success_PerStory_${msid}_${oldPRC}`;
        } else {
          gaAction = `TOIPlus_PAID_success_PerStory_${msid}`;
        }
      } else if (
        planAccessType === 'TOI_PLUS' ||
        planAccessType === 'TOIPLUS' ||
        planAccessType === 'TOI+' ||
        planAccessType === 'TIMESPRIME'
      ) {
        if (oldPRC) {
          if (msid && storyTitle) {
            gaAction = `TOIPlus_PRCNA_success_story_${msid}_(${oldPRC},${prc})`;
            gaLabel = `Ps-${prc}`;
          } else {
            gaAction = `TOIPlus_PRCNA_success_(${oldPRC},${prc})`;
            gaLabel = `Ps-${prc}`;
          }
        } else if (initMsid && initStoryTitle) {
          gaAction = `TOIPlus_PAID_success_story_${initMsid}`;
          gaLabel = initStoryTitle;
        } else {
          gaAction = `TOIPlus_PAID_success`;
          gaLabel = `Ps-${prc}/${planName || 'TOIPlusPAID'}`;
        }
      } else if (
        planAccessType === 'PAY_PER_ARTICLE' &&
        storedPlanOption === 'credOption'
      ) {
        gaLabel = storyTitle;
        gaAction = `TOIPlus_PAID_cred_success`;
      } else {
        gaAction = `TOIPlus_PAID_success`;
        gaLabel = `Ps-${prc}/${planName || 'TOIPlusPAID'}`;
      }
      localStorage.removeItem('oldPRC');
    } else if (status === PAYMENT_STATUS_SCREEN.PAYMENT_PENDING) {
      if (msid) {
        gaAction = `TOIPlus_PRCNA_pending_story_${msid}_${oldPRC}`;
      } else {
        gaAction = `TOIPlus_PRCNA_pending_${oldPRC}`;
      }
      gaLabel = `Ps-${prc}`;
    } else if (status === PAYMENT_STATUS_SCREEN.PAYMENT_FAILED) {
      gaAction = 'TOIPlus_PAID_fail';
      gaLabel = `Ps-${prc}`;
    } else if (status === PAYMENT_STATUS_SCREEN.PAYMENT_UNREACHABLE) {
      gaAction = 'TOIPlus_NoResponsefromserver_PostPayment';
      gaLabel = `Ps-${prc}`;
      if (planAccessType === 'PAY_PER_ARTICLE') {
        gaAction = `${gaAction}_PerStory`;
      }
    }
    if (!(msid && storyTitle && initMsid && initStoryTitle)) {
      const PostPaymentData = {
        msid,
        storyTitle,
        prc,
        oldPRC,
        screenType: status,
        clickNudgeInfoValue,
        planAccessType,
      };
      alertLogger('postProcessOrder_Log', PostPaymentData);
    }
    // console.log('testing==', msid, storyTitle, prc, oldPRC, status);
    fireGA(gaAction, gaLabel);
  };
  // const setCredErrorStatusFn = err => {
  //   if (err === 'INSUFFICIENT_CRED_BALANCE') {
  //     setCredErrorStatus(err);
  //   } else if (err === 'cred_login_failure') {
  //     setCredErrorStatus('NO_CRED_ACCOUNT');
  //   } else {
  //     setCredErrorStatus('PaymentFailure');
  //   }
  // };

  const fetchOrderStatus = ordersId => {
    localStorage.setItem('paymentSuccess', true);
    let orderStatus;
    const options = {};
    // options.params = {
    //   orderId: ordersId,
    //   cc: geoCountry,
    //   fv: '745',
    //   retryCount,
    // delayPaymentStatus: isRetryClick ? null : 180,
    // };

    // options.headers = {
    // ssoId: Cookie.get('ssoid') || Cookie.get('ssoId') || '',
    // ticketId: Cookie.get('TicketId') || Cookie.get('ticket') || '',
    // };
    // const requestUrl = isWapView
    //   ? TOI_SUBS_FETCH_ORDER_STATUS_MWEB
    //   : TOI_SUBS_FETCH_ORDER_STATUS_WEB;
    options.headers = {
      'X-CLIENT-ID': isWapView ? ET_X_CLIENT_ID_WAP : ET_X_CLIENT_ID_WEB,
      'X-SITE-APP-CODE': ET_X_SITE_APP_CODE,
    };
    // const requestUrl = `${ET_SUBSCRIPTION_STATUS}/subscription/merchant/TOI/product/TOIPLUS/initTrans/6513c5639f1c7244fa0a968b/findSubscription`;
    const requestUrl = `${ET_SUBSCRIPTION_STATUS}/subscription/merchant/TOI/product/TOIPLUS/initTrans/${ordersId}/findSubscription`;

    makeRequest
      .get(requestUrl, options)
      .then(statusRes => {
        const fetchSubscriptionData = statusRes.data.subscriptionDetail;
        const { userDetail } = statusRes.data;
        // if (
        //   fetchSubscriptionData &&
        //   // statusRes?.data?.data &&
        //   // Array.isArray(statusRes.data.data.orders) &&
        //   // statusRes.data.data.orders.length > 0 &&
        //   // statusRes.data.data.orders[0]?.paymentStatus ===
        //   //   PAYMENT_STATUS_SCREEN.PAYMENT_SUCCESS &&
        //   startGstFlowNode &&
        //   !hasGSTFormFilled
        // ) {
        //   callback(true);
        //   return;
        // }
        if (
          fetchSubscriptionData
          // orderStatus !== PAYMENT_STATUS_SCREEN.PAYMENT_UNREACHABLE &&
          // statusRes?.data?.data &&
          // Array.isArray(statusRes.data.data.orders) &&
          // statusRes.data.data.orders.length > 0
        ) {
          // paymentData = statusRes.data.data.orders[0];
          // setCredErrorStatusFn(paymentData.paymentError);
          // setPlanId(fetchSubscriptionData.planCode);
          // orderStatus = paymentData.paymentStatus;
          orderStatus = PAYMENT_STATUS_SCREEN.PAYMENT_SUCCESS;
          const planAccessType = fetchSubscriptionData.planName;
          let clickNudgeInfoValue;
          if (
            typeof window !== 'undefined' &&
            window.localStorage &&
            localStorage.getItem('nudgeClickInfo')
          ) {
            clickNudgeInfoValue = JSON.parse(
              localStorage.getItem('nudgeClickInfo'),
            );
          }
          // if (
          //   orderStatus === PAYMENT_STATUS_SCREEN.PAYMENT_FAILED ||
          //   orderStatus === PAYMENT_STATUS_SCREEN.PAYMENT_PENDING
          // ) {
          //   const orderIdStorageDetails =
          //     localStorage.getItem(BROWSER_STORAGE_KEY) &&
          //     JSON.parse(localStorage.getItem(BROWSER_STORAGE_KEY));
          //   if (orderIdStorageDetails) {
          //     clearBrowserStorageKey(
          //       60,
          //       BROWSER_STORAGE_KEY,
          //       orderIdStorageDetails.stored_at,
          //     );
          //   }
          // }
          // setAccessType(planAccessType);
          // duration = paymentData.planDetails?.durationDescription;
          // setDurationForCD(duration);
          // setOrderId(userDetail.transcode);
          if (planAccessType === 'PAY_PER_ARTICLE') {
            planName = 'PAY_PER_ARTICLE';
            sessionStorage.setItem('pps_planstatus', orderStatus);
          } else if (planAccessType === 'TOI_PLUS') {
            planName = 'TOIPlusPAID';
          } else if (planAccessType === 'TIMESPRIME') {
            planName = 'TOIPlus_TimesPrimePaid';
          } else {
            planName = fetchSubscriptionData.planName;
          }
          // setPlanNameForCD(planAccessType);
          if (storedPlanOption === 'credOption') {
            // fireCustomDimension(
            //   `CREDUnlock_${credData?.credBalance}`,
            //   'dimension33',
            // );
          } else {
            fireCustomDimension(
              `${
                // planName === 'PAY_PER_ARTICLE' ? 'TOIPlusPerStory' : planName
                planAccessType
              }_${duration}`,
              'dimension33',
            );
          }
          if (
            orderStatus === PAYMENT_STATUS_SCREEN.PAYMENT_SUCCESS ||
            orderStatus === PAYMENT_STATUS_SCREEN.PAYMENT_FAILED
          ) {
            removeFromLocalStorage([
              'paymentSuccess',
              'toi_cookie',
              'retry_popup_closed',
              'nudgeClickInfo',
            ]);
            // renderScreen(orderStatus, isRetryClick);
            if (orderStatus === PAYMENT_STATUS_SCREEN.PAYMENT_SUCCESS) {
              gtag('event', 'conversion', {
                send_to: 'AW-877820074/83xdCPmvgoQDEKrxyaID',
                value: `${fetchSubscriptionData.finalBillingAmount || 0}`,
                currency: `${fetchSubscriptionData.currency || ''}`,
                transaction_id: `${userDetail.transcode}`,
              });
              if (
                typeof window !== 'undefined' &&
                typeof window.fbq === 'function'
              ) {
                window.fbq('track', 'Purchase', {
                  currency: `${fetchSubscriptionData.currency || ''}`,
                  value: `${fetchSubscriptionData.finalBillingAmount || 0}`,
                });
              }
              const cookieType = getCookie('utm_source');
              switch (cookieType) {
                case 'admitad': {
                  const img = document.createElement('img');
                  const uniqueId = getCookie('utm_source_id');
                  const url = `https://ad.admitad.com/r?campaign_code=eefe603b78&action_code=1&uid=${uniqueId}&order_id=${
                    userDetail.transcode
                  }&tariff_code=1&price=${fetchSubscriptionData.finalBillingAmount ||
                    0}&payment_type=sale&currency_code=${fetchSubscriptionData.currency ||
                    ''}`;
                  img.src = url;
                  img.width = '1';
                  img.height = '1';
                  document.body.appendChild(img);
                  break;
                }
                case 'xapads': {
                  const saleAmount = Math.ceil(
                    fetchSubscriptionData.finalBillingAmount / 2,
                  );
                  const url = `https://trck.xapads.com/pixel?adid=60b9c6969c0169097767493b&goal_value=subscription&sale_amount=${saleAmount}&currency=INR&sub1=${
                    userDetail.transcode
                  }&sub2=${fetchSubscriptionData.finalBillingAmount ||
                    0}&sub3=${geoCountry}`;
                  document.body.appendChild(`<img src='${url}'>`);
                  break;
                }
                case 'affle': {
                  const url = `https://cost.affcost.com/pixel?adid=60b89b72c3d5391cfa6a5317&sub1=${
                    userDetail.transcode
                  }&sale_amount=${fetchSubscriptionData.finalBillingAmount ||
                    0}`;
                  document.body.appendChild(`<img src='${url}'>`);
                  break;
                }
                default:
              }
              // loadUserPrcData().then(data => {
              //   if (data && Array.isArray(data.otps) && data.otps.length > 0) {
              //     sessionStorage.setItem('paidstories', [data.otps]);
              //   }
              //   if (
              //     storedPlanOption === 'credOption' &&
              //     Array.isArray(data.credOtps) &&
              //     data.credOtps?.length > 0
              //   ) {
              //     sessionStorage.setItem('paidCredstories', [data.credOtps]);
              //   }
              // });
              const updatedUrl = window.location.href.replace(
                'transcode',
                'transcode_exp',
              );
              window.history.pushState({}, '', updatedUrl);
            }
          }
          // else if (orderStatus === PAYMENT_STATUS_SCREEN.PAYMENT_PENDING) {
          //   if (typeof localStorage !== 'undefined') {
          //     localStorage.setItem('oldPRC', prc);
          //   }
          //   if (count <= 2) {
          //     timerId = setTimeout(() => {
          //       setCount(count + 1);
          //     }, 2000);
          //   } else if (count > 2) {
          //     clearTimeout(timerId);
          //     // renderScreen(orderStatus, isRetryClick);
          //   }
          // }

          fireGAOnApiResponse(orderStatus, planAccessType, {
            clickNudgeInfoValue,
          });
        }
      })
      .catch(() => {
        // orderStatus = PAYMENT_STATUS_SCREEN.PAYMENT_UNREACHABLE;
        fireGAOnApiResponse(orderStatus, null);
        // renderScreen(orderStatus, isRetryClick);
      });
  };

  // const showScreen = (status, props) => {
  //   let screen = null;
  //   let gaAction = '';
  //   let gaLabel = '';
  //   if (storedPlanOption === 'credOption') {
  //     fireCustomDimension(`CREDUnlock_${credData?.credBalance}`, 'dimension33');
  //   } else {
  //     fireCustomDimension(
  //       planNameForCD === 'PAY_PER_ARTICLE'
  //         ? 'TOIPlusPerStory'
  //         : `${planNameForCD}_${durationForCD}`,
  //       'dimension33',
  //     );
  //   }
  //   if (status === PAYMENT_STATUS_SCREEN.PAYMENT_SUCCESS) {
  //     sessionStorage.removeItem('nativePrc');
  //     sessionStorage.removeItem('expirydate');
  //     sessionStorage.setItem('planName', planName);
  //     localStorage.setItem('planName', planName);
  //     Cookie.remove('ipr', '/', '.indiatimes.com');
  //     if (accessType === 'PAY_PER_ARTICLE') {
  //       hideLoader();
  //       if (storedPlanOption === 'credOption') {
  //         gaLabel = `Ps-${prc}`;
  //         gaAction = 'TOIPlus_Payment_success_CRED_view';
  //         screen = (
  //           <CredStatusScreen
  //             hideStatus={hideStatus}
  //             userData={userData}
  //             prc={prc}
  //             userPhone={userPhone}
  //             fireGA={fireGA}
  //             status="success"
  //             msid={msid}
  //             storyTitle={storyTitle}
  //           />
  //         );
  //       } else {
  //         gaLabel = `Ps-${prc}/PAY_PER_ARTICLE`;
  //         gaAction = 'TOIPlus_PAID_success_PerStory_view';
  //         screen = (
  //           <PerStorySuccessScreen
  //             hideStatus={hideStatus}
  //             userData={userData}
  //             prc={prc}
  //             userPhone={userPhone}
  //             fireGA={fireGA}
  //             msid={msid}
  //             storyTitle={storyTitle}
  //           />
  //         );
  //       }
  //       if (screenToShow.showScreenGA) {
  //         fireCustomDimension(orderId, 'dimension50');
  //         fireGA(gaAction, gaLabel);
  //         setScreenToShow({
  //           ...screenToShow,
  //           showScreenGA: false,
  //         });
  //       }
  //     } else if (accessType === 'TOI_PLUS') {
  //       gaLabel = `Ps-${prc}/${planName || 'TOIPlusPAID'}`;
  //       gaAction = 'TOIPlus_PAID_success_view';
  //       hideLoader();
  //       if (screenToShow.showScreenGA) {
  //         fireCustomDimension(orderId, 'dimension50');
  //         if (remainingDays > -1) {
  //           if (inGracePeriod) {
  //             fireCustomDimension(remainingDays, 'dimension52');
  //           } else if (inPreExpirePeriod) {
  //             fireCustomDimension(remainingDays, 'dimension51');
  //           }
  //         }
  //         firePurchaseTypeDimension();
  //         fireGA(gaAction, gaLabel);
  //         setScreenToShow({
  //           ...screenToShow,
  //           showScreenGA: false,
  //         });
  //       }
  //       screen = <SuccessScreen {...props} />;
  //     } else if (accessType === 'TIMESPRIME') {
  //       gaLabel = `Ps-${prc}/${planName || 'TOIPlusPAID'}`;
  //       gaAction = 'TOIPlus_PAID_success_view';
  //       hideLoader();
  //       if (screenToShow.showScreenGA) {
  //         fireCustomDimension(orderId, 'dimension50');
  //         if (remainingDays > -1) {
  //           if (inGracePeriod) {
  //             fireCustomDimension(remainingDays, 'dimension52');
  //           } else if (inPreExpirePeriod) {
  //             fireCustomDimension(remainingDays, 'dimension51');
  //           }
  //         }
  //         firePurchaseTypeDimension();
  //         fireGA(gaAction, gaLabel);
  //         setScreenToShow({
  //           ...screenToShow,
  //           showScreenGA: false,
  //         });
  //       }
  //       screen = (
  //         <TimesPrimeSuccessScreen
  //           hideStatus={hideStatus}
  //           prcStatusDetails={prcStatusDetails}
  //           userPhone={userPhone}
  //           fireGA={fireGA}
  //           prc={prc}
  //           planName={planName}
  //         />
  //       );
  //     } else {
  //       hideLoader();
  //       screen = null;
  //     }
  //     setNativePrc(isWapView);
  //   } else if (
  //     status === PAYMENT_STATUS_SCREEN.PAYMENT_PENDING &&
  //     !localStorage.getItem('retry_popup_closed') &&
  //     count > 2
  //   ) {
  //     gaLabel = `Ps-${prc}`;
  //     gaAction = 'TOIPlus_Payment_Pending_View';
  //     if (accessType === 'PAY_PER_ARTICLE') {
  //       gaAction = 'TOIPlus_Payment_Pending_PerStory_View';
  //     }
  //     hideLoader();
  //     if (screenToShow.showScreenGA) {
  //       firePurchaseTypeDimension();
  //       if (remainingDays > -1) {
  //         if (inGracePeriod) {
  //           fireCustomDimension(remainingDays, 'dimension52');
  //         } else if (inPreExpirePeriod) {
  //           fireCustomDimension(remainingDays, 'dimension51');
  //         }
  //       }
  //       fireGA(gaAction, gaLabel);
  //       setScreenToShow({
  //         ...screenToShow,
  //         showScreenGA: false,
  //       });
  //     }
  //     screen = (
  //       <PendingScreen
  //         hideStatus={hideStatus}
  //         triggerMailOnContactUs={triggerMailOnContactUs}
  //         fetchOrderStatus={fetchOrderStatus}
  //         orderId={orderId}
  //         hideLoader={hideLoader}
  //         isWapView={isWapView}
  //         geoCountry={geoCountry}
  //         prc={prc}
  //         fireGA={fireGA}
  //         viewLoader={viewLoader}
  //       />
  //     );
  //   } else if (status === PAYMENT_STATUS_SCREEN.PAYMENT_FAILED) {
  //     hideLoader();
  //     if (storedPlanOption === 'credOption') {
  //       gaAction = 'TOIPlus_Payment_fail_CRED_view';
  //       gaLabel = `Ps-${prc}`;
  //       screen = (
  //         <CredStatusScreen
  //           hideStatus={hideStatus}
  //           userData={userData}
  //           prc={prc}
  //           userPhone={userPhone}
  //           fireGA={fireGA}
  //           status={credErrorStatus}
  //           prcStatusDetails={prcStatusDetails}
  //           msid={msid}
  //           storyTitle={storyTitle}
  //         />
  //       );
  //     } else {
  //       gaAction = 'TOIPlus_PAID_fail_view';
  //       if (accessType === 'PAY_PER_ARTICLE') {
  //         gaAction = 'TOIPlus_PAID_fail_PerStory_view';
  //       }
  //       gaLabel = `Ps-${prc}/${planName || 'TOIPlusPAID'}`;
  //       screen = (
  //         <FailureScreen
  //           {...props}
  //           planId={planId}
  //           msid={msid}
  //           storyTitle={storyTitle}
  //           accessType={accessType}
  //         />
  //       );
  //     }
  //     if (screenToShow.showScreenGA) {
  //       fireCustomDimension(orderId, 'dimension50');
  //       fireGA(gaAction, gaLabel);
  //       setScreenToShow({
  //         ...screenToShow,
  //         showScreenGA: false,
  //       });
  //     }
  //   } else if (status === PAYMENT_STATUS_SCREEN.PAYMENT_UNREACHABLE) {
  //     hideLoader();
  //     screen = (
  //       <Unreachable
  //         {...props}
  //         planId={planId}
  //         msid={msid}
  //         storyTitle={storyTitle}
  //         accessType={accessType}
  //       />
  //     );
  //   } else {
  //     hideLoader();
  //     screen = null;
  //   }

  //   if (screen !== null) {
  //     disableBodyScroll();
  //   } else {
  //     enableBodyScroll();
  //   }
  //   return screen;
  // };

  useEffect(
    () => {
      const checkForCreateOrderFailure =
        localStorage.getItem(BROWSER_STORAGE_KEY) &&
        JSON.parse(localStorage.getItem(BROWSER_STORAGE_KEY))?.orderStatus;
      // const checkForCredLoginFailure =
      //   localStorage.getItem('cred_login_failure') &&
      //   JSON.parse(localStorage.getItem('cred_login_failure'));
      // if (!checkForCreateOrderFailure && !checkForCredLoginFailure) {
      // console.log('123>>', loading, userPrcData);
      if (!checkForCreateOrderFailure) {
        const orderIdFromCache = getCachedOrderId();
        if (
          orderIdFromCache &&
          (loading !== LOADING_STATE.LOADING && loading === LOADING_STATE.DONE)
        ) {
          // loadUserPrcData().then(() => {
          fetchOrderStatus(orderIdFromCache, 0, false);
          // });
        }
      }
    },
    [userPrcData, loading],
  );

  // useEffect(
  //   () => {
  //     const checkForCreateOrderFailure =
  //       localStorage.getItem(BROWSER_STORAGE_KEY) &&
  //       JSON.parse(localStorage.getItem(BROWSER_STORAGE_KEY))?.orderStatus;
  //     // const checkForCredLoginFailure =
  //     //   localStorage.getItem('cred_login_failure') &&
  //     //   JSON.parse(localStorage.getItem('cred_login_failure'));
  //     // if (!checkForCreateOrderFailure && !checkForCredLoginFailure) {
  //     if (!checkForCreateOrderFailure) {
  //       if (count !== 0) {
  //         fetchOrderStatus(orderId, count, false);
  //       }
  //     } else {
  //       setScreenToShow({
  //         ...screenToShow,
  //         statusScreen: PAYMENT_STATUS_SCREEN.PAYMENT_FAILED,
  //       });
  //       // if (checkForCreateOrderFailure) {
  //       //   setCredErrorStatusFn(checkForCreateOrderFailure);
  //       // }
  //       // if (checkForCredLoginFailure) {
  //       //   setCredErrorStatusFn(checkForCredLoginFailure);
  //       // }
  //     }
  //   },
  //   [count, hasGSTFormFilled],
  // );

  return (
    <>
      {/* {screenToShow.statusScreen &&
        showScreen(screenToShow.statusScreen, {
          hideStatus,
          prcStatusDetails,
          userData,
          startTOIPaymentFlow,
          triggerMailOnContactUs,
          orderId,
          userPhone,
          currencyCode,
        })} */}
    </>
  );
};

ToiSubscriptionStatus.propTypes = {
  isWapView: PropTypes.bool.isRequired,
  userData: PropTypes.shape({}),
  // currencyCode: PropTypes.string,
  msid: PropTypes.string,
  storyTitle: PropTypes.string,
  // startTOIPaymentFlow: PropTypes.func.isRequired,
  // triggerMailOnContactUs: PropTypes.func.isRequired,
  // hideLoader: PropTypes.func.isRequired,
  // viewLoader: PropTypes.func.isRequired,
  geoCountry: PropTypes.string,
  // userPhone: PropTypes.string,
  // prcStatusDetails: PropTypes.shape({}),
  // hasGSTFormFilled: PropTypes.bool,
  // startGstFlowNode: PropTypes.bool,
};

ToiSubscriptionStatus.defaultProps = {
  userData: {},
  // currencyCode: '',
  msid: '',
  storyTitle: '',
  geoCountry: '',
  // userPhone: '',
  // prcStatusDetails: {},
  // hasGSTFormFilled: false,
  // startGstFlowNode: false,
};
const mapStateToProps = state => ({
  userPrcData: state.login.userPrcData,
  loading: state.login.isLoading,
});

// const mapDispatchToProps = dispatch => ({
//   loadUserPrcData: params => dispatch(getUserPrcData(params)),
// });

export default connect(mapStateToProps, null)(ToiSubscriptionStatus);
// export default ToiSubscriptionStatus;
